export const PG_ROLES = [
  "Pelajar",
  "Graduan Baharu",
  "Pekerja",
  "Pengurus",
  "Profesional",
  "Usahawan",
  "Suri Rumah",
  "Ibu Bapa / Penjaga",
  "Sedang Mencari Kerja",
  "Pesara",
  "Lain-lain",
];

export const PG_EMPLOYMENT = [
  "Bekerja sepenuh masa",
  "Bekerja separuh masa",
  "Bekerja sendiri",
  "Pelajar",
  "Sedang mencari kerja",
  "Menjaga keluarga",
  "Bersara",
];

export const PG_EXPERIENCE = [
  "Belum bekerja",
  "Kurang 2 tahun",
  "2 – 5 tahun",
  "5 – 10 tahun",
  "10 – 20 tahun",
  "Lebih 20 tahun",
];

export const PG_EDUCATION = [
  "Sekolah Menengah",
  "Sijil",
  "Diploma",
  "Ijazah Sarjana Muda",
  "Sarjana",
  "PhD",
  "Lain-lain",
];

export const PG_RESPONSIBILITY = [
  "Diri sendiri",
  "Keluarga",
  "Pasukan di tempat kerja",
  "Pelajar / anak didik",
  "Komuniti",
  "Lain-lain",
];

export const PG_REASON = [
  "Mencari hala tuju",
  "Meningkatkan keyakinan diri",
  "Memperbaiki disiplin & produktiviti",
  "Menghadapi perubahan besar",
  "Persediaan kerjaya",
  "Pembangunan kepimpinan",
  "Sekadar ingin mengenali diri",
  "Lain-lain",
];
